module.exports = __webpack_public_path__ + "static/thumbnail-d654f419ec44df2b62d5a3b82723cd3f.png";